import {MessageNode} from "../../../messageObject/MessageNode.ts";
import messageIdMapping from "../../../IdMappings/MessageIdMapping.ts";
import {isIde} from "../../../misc/envNameUtils.ts";

export const trimMessages = (rootNode: any, messagesSequence: any, turnsToKeep: number, importantMessageIds: Set<string>, systemMessage: string) => {
    const messagesArray: any[] = [];
    const trimmedMessages: any[] = [];
    // Make a copy so it's mutable
    importantMessageIds = new Set(importantMessageIds);
    const contextDetails = {numOfImages: 0, convoHasAudio: false, convoHasVideo: false, numberOfTurns: 0, approxTokens: 0};
    contextDetails.approxTokens += Math.ceil((systemMessage.length / 4) * 1.25);

    // Gather every message from the DAG from top to bottom
    let currentNode: MessageNode | null = rootNode;
    for (const sequenceIndex of messagesSequence) {
        if (currentNode?.children && sequenceIndex < currentNode.children.length) {
            currentNode = messageIdMapping[currentNode.children[sequenceIndex]];
        } else {
            currentNode = null;
            break;
        }

        if (!currentNode || !currentNode.message || currentNode.message.isLoading) continue;

        messagesArray.push(currentNode);
    }

    // Trim messages from bottom going upwards
    let userMessagesSeen = 0;
    let hasSeenAudio = false;
    let hasSeenVideo = false;

    for (let i = messagesArray.length - 1; i >= 0; i--) {
        const message = messagesArray[i].message;
        const messageId = messagesArray[i].id;

        // Skip the last message if it's from the assistant
        if (i === messagesArray.length - 1 && message.role === "assistant") continue;

        const shouldKeep = userMessagesSeen < turnsToKeep || importantMessageIds.has(messageId);
        if (shouldKeep) {
            if (message.role === "user") {
                if (message.isTemp === true) delete message.isTemp;
                else userMessagesSeen++;
            }
            if (Array.isArray(message.content)) {
                // Filter out excess audio/video files
                message.content = message.content.filter((item: any) => {
                    if (item.type === "audio") {
                        if (hasSeenAudio) return false;
                        hasSeenAudio = true;
                        contextDetails.convoHasAudio = true;
                        return true;
                    }
                    else if (item.type === "video") {
                        if (hasSeenVideo) return false;
                        hasSeenVideo = true;
                        contextDetails.convoHasVideo = true;
                        return true;
                    }
                    return true;
                });

                // Calculate tokens for remaining content
                message.content.forEach((item: any) => {
                    if (item.type === "image") {
                        contextDetails.numOfImages += 1;
                        contextDetails.approxTokens += 1500;
                    }
                    else {
                        if (item.type === "file" || item.type === "link") {
                            const contentLength = item.fileContent?.length || 0;
                            contextDetails.approxTokens += Math.ceil((contentLength / 4) * 1.25);
                        }
                        else {
                            const textLength = item.text?.length || 0;
                            contextDetails.approxTokens += Math.ceil((textLength / 4) * 1.25);
                        }
                    }
                });
            }

            if (message.promptPrefix) contextDetails.approxTokens += Math.ceil((message.promptPrefix.length / 4) * 1.25);
            if (message.promptPostfix) contextDetails.approxTokens += Math.ceil((message.promptPostfix.length / 4) * 1.25);

            trimmedMessages.unshift(messagesArray[i]);
        }

        if (userMessagesSeen === turnsToKeep && importantMessageIds.size === 0) break;
    }
    contextDetails.numberOfTurns = userMessagesSeen;

    return {trimmedMessages, contextDetails};
}

export const cacheLastMeaningfulMessage = (formattedMessages: any[], environment: string, mode: string, model: string) => {
    if (!model.includes("Claude") || !isIde(environment)) return formattedMessages;

    let lastMeaningfulMessageIndex = null;
    let isGatherContext = false;

    for (let i = formattedMessages.length - 1; i >= 0; i--) {
        const message = formattedMessages[i];
        if (message.role === "user") {
            lastMeaningfulMessageIndex = i;
            break;
        }
        else if (message.isGatherContext) {
            lastMeaningfulMessageIndex = i;
            isGatherContext = true;
            break;
        }
    }

    if (lastMeaningfulMessageIndex !== null) {
        if (mode !== "chat" || isGatherContext) {
            const lastMeaningfulMessage = formattedMessages[lastMeaningfulMessageIndex];
            if (typeof lastMeaningfulMessage.content === 'string') {
                lastMeaningfulMessage.content = [{type: 'text', text: lastMeaningfulMessage.content}];
            }
            lastMeaningfulMessage.content[lastMeaningfulMessage.content.length - 1] = {
                ...lastMeaningfulMessage.content[lastMeaningfulMessage.content.length - 1],
                cache_control: { type: "ephemeral" }
            };
        }
    }

    return formattedMessages;
}

export const checkToolWasUsed = (trimmedMessages: any[], index: number, id: string) => {
    for (let i = index + 1; i < trimmedMessages.length; i++) {
        if (trimmedMessages[i].message.role === "tool" && trimmedMessages[i].message.tool_call_id === id) {
            return true;
        }
        if (trimmedMessages[i].message.role !== "tool") return false;
    }

    return false;
}
